<template>
<div id="app" :class="{isNew}">
    <div class="index-loading-box" id="index-loading-box">
        <img src="../src/assets/loading.gif">
    </div>
    <router-view />
</div>
</template>

<script>
export default {
    name: 'app',
    computed: {
        isNew() {
            // let isNew = !!(this.$route.query.isNew - 0)
            // this.$store.commit('setIsNew', isNew)
            // return isNew
            return this.$store.state.isNew
        },
    },
    created(){
        // 2024年2月23日 海康直播线上环境路径修改 线上环境引入DecodeWorker.js时路径前追加/h5s 具体代码部分看public/h5-player/h5player.min.js
        if(['scenic.test.tuliyou.com', 'scenic.tuliyou.com'].includes(location.host)) {
            window.isBuild = true
        } else window.isBuild = false
        if(this.$route.query.lang == 'en') {
            this.$i18n.locale = 'en'
            document.querySelector('html').style.setProperty('--my_location_icon', `url(${ require('./assets/my_location_english_icon.png') })`)
        }
        else this.$i18n.locale = 'zn'
        // new window.VConsole()
        let ua = window.navigator.userAgent.toLowerCase()
        if (ua.match(/MicroMessenger/i) == 'micromessenger') {
            //   判断是微信环境，继续判断是否为小程序
            wx.miniProgram.getEnv((res)=>{
                console.log('res.miniprogram:',res.miniprogram)
                if (res.miniprogram) {
                    this.$store.commit('setIsWeiXin',true)
                } else {
                    this.$store.commit('setIsWeiXin',false)
                }
            })
        }else {
            //非微信环境，返回false
            this.$store.commit('setIsWeiXin',false)
        }

        // 判断是抖音环境
        if (ua.match(/aweme/i) == 'aweme') {
            this.$store.commit('setIsWeiXin',true)
        }

        // 判断是否为华为鸿蒙os环境 注：此变量由华为鸿蒙os中webview的java代码注入
        if(window.getHarmonyosIdentifying && window.getHarmonyosIdentifying.call) this.$store.commit('setIsHarmonyosIdentifying', true)
        // this.$store.commit('setIsHarmonyosIdentifying', true)


    }
}
</script>

<style>
* {
    padding: 0;
    margin: 0;
    box-sizing: border-box;
}
img {
    object-fit: cover;
}

html,
body {
    height: 100%;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
}

body {
    overflow: hidden;
}

@media screen and (min-width: 320px) {
    html {
        font-size: 42.5px;
    }
}

@media screen and (min-width: 360px) {
    html {
        font-size: 48px;
    }
}

@media screen and (min-width: 400px) {
    html {
        font-size: 53px;
    }
}

@media screen and (min-width: 440px) {
    html {
        font-size: 58.5px;
    }
}

@media screen and (min-width: 480px) {
    html {
        font-size: 64px;
    }
}

@media screen and (min-width: 640px) {
    html {
        font-size: 85px;
    }
}

html {
    font-size: 13.33vw;
}

@media screen and (min-width: 750px) {
    html {
        font-size: 100px;
    }
}

#app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
}

.index-loading-box {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 200;
    background: #fff;
    font-size: 0.26rem;
    text-align: center;
    padding-top: 40%;
    opacity: 1;
    transition: opacity 0.5s, visibility 0s 0.5s;
    visibility: visible;
}

.index-loading-box.hide {
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.5s, visibility 0s 0.5s;
}

.index-loading-box img {
    width: 3.8rem;
    height: 2.53rem;
    display: inline-block;
}
html {
    --my_location_icon: url(./assets/my_location_icon.png);
}
/* 用户当前位置点样式 */
.custor-marker {
    position: relative;
    width: 110px;
    height: 82px;
    background: var(--my_location_icon) no-repeat center center / 110px 82px;
}

.user-photo {
    position: absolute;
    top: 42px;
    left: 28px;
    width: 23px;
    height: 23px;
    background: url(./assets/photo.png) no-repeat center center / 23px;
}

/* 地图上点样式 */
.custor-marker-point {
    position: relative;
}

.top-info-box {
    background: #fff;
    border-radius: 10px;
    /* padding: 8px 8px 8px 64px; */
    padding: .2rem;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    font-size: 14px;
    text-align: left;
    min-height: 56px;
    align-items: center;
    display: flex;
    flex-direction: column;
}

.top-info-box::after {
    position: absolute;
    bottom: -9px;
    left: 50%;
    content: "";
    border-top: 10px solid #fff;
    border-left: 10px solid transparent;
    border-right: 10px solid transparent;
    transform: translateX(-50%);
}

.top-info-box .top-title {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: .28rem;
    font-weight: bold;
    color: #333;
    
}

.top-info-box .top-title .spot-name{
    max-width: 3.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.top-info-box .bottom{
    display: flex;
    margin-top: .1rem;
    min-height: .1rem;
    width: 100%;
}

.top-info-box .bottom img{
    width: 1rem;
    height: .8rem;
    margin-right: .2rem;
    background-color: #fff;
}

.top-info-box .info-box {
    /* white-space: nowrap; */
    min-height: .1rem;
}

.top-info-box .info-box .distance {
    color: #666666;
    font-size: .24rem;
    max-width: 2.5rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.top-info-box .info-box .btn{
    margin-top: .1rem;
}

.top-info-box .info-box .btn .detail {
    height: .4rem;
    line-height: .4rem;
    border: .02rem solid #48c1ff;
    border-radius: .2rem;
    font-size: .22rem;
    color:#48c1ff;
    background-color: #fff;
    padding: 0 .15rem;
    margin-right: .1rem;
}
.top-info-box .info-box .btn .detail-scenic{
    border: .02rem solid #009D7A;
    color:#009D7A;
}

.top-info-box .info-box .btn .go-address {
    height: .4rem;
    line-height: .4rem;
    border-radius: .2rem;
    font-size: .22rem;
    color:#fff;
    padding: 0 .15rem;
    padding-left: .49rem;
    border: none;
    background:#48c1ff url('./assets/go_address_icon.png') no-repeat .15rem center/.24rem .24rem;
}
.top-info-box .info-box .btn .go-address-scenic{
    background:#009D7A url('./assets/go_address_icon.png') no-repeat .15rem center/.24rem .24rem;
}

.top-info-box .audio-btn {
    /* width: 30px;
    height: 30px;
    margin-left: 5px; */
    width: .36rem;
    height: .36rem;
    /* margin-left: .05rem; */
    background: url(./assets/ej.png) no-repeat center center / 100%;
    display: none;
    flex-shrink: 0;
}

.top-info-box .audio-btn.show {
    display: block;
}
.amap-markers,
.amap-marker {
    z-index: 10000 !important;
}
.custor-marker-point .bottom-name {
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translate(-50%, 110%);
    font-size: 14px;
    background: #fff;
    border: 1px solid #000;
    border-radius: 5px;
    padding: 0 10px;
    white-space: nowrap;
    display: none;
}

.custor-marker-point .bottom-name.show {
    display: inline-block;
}

.amap-icon{
    width: .56rem!important;
    height: .67rem!important;
    left: .06rem;
}
.amap-icon img{
    width: .56rem!important;
    height: .67rem!important;
}
/* 修改高德默认信息框样式 */
.amap-marker-label {
    border: none;
    padding: 0;
    border-radius:.1rem;
    /* font-size: .2rem;
    color:#333333;
    height:.36rem;
    line-height: .36rem;
    background:rgba(255,255,255,1);
    border:.02rem solid rgba(126,126,126,1);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    padding: .04rem .03rem 0 .03rem;
    max-width:2rem;
    padding: 0 4px;
    box-sizing: border-box; */
    /* width:2rem; */
    /* left: -0.37rem!important; */
    /* left: 50% !important; */
    /* transform: translateX(-50%) !important; */
    /* text-align: center; */
}
/* .amap-marker-label p{
    font-size: .2rem;
    color:#333333;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
} */
.amap-marker-label .label-item {
    position: relative;
    border-radius:.1rem;
    /* position: fixed; */
    /* top: 50%; */
    /* left: 50%; */
    /* transform: translate(-50%, -50%); */
    /* z-index: 2; */
}
.amap-marker-label img {
    position: absolute;
    width: 25px !important;
    height: 25px !important;
    left: -12px;
    top: 50%;
    transform: translateY(-50%);
}
.amap-marker-label span {
    display: block;
    border: 1px solid #707070;
    border-radius: 3px;
    height: 18px;
    line-height: 18px;
    /* padding: 0 11px 0 16px; */
    padding: 0 .1rem 0 .26rem;
    color: #333;
    font-size: 12px;
    background: #fff;
}
.label-item img{
    display: none;
}
.label-item span{
    padding: 0 .1rem 0 .1rem;
}

.label-item.prize img{
    display: initial;
}
.label-item.prize span{
    padding: 0 .1rem 0 .26rem;
}

.amap-copyright,
.amap-logo {
    display: none !important;
    visibility: hidden !important;
}

.marker-clusterer-icon {
    width: .56rem;
    height: .67rem;
    line-height: .6rem !important;
    font-size: 14px;
    line-height: 30px;
    background: url(./assets/markerClusterer.png) no-repeat center center / auto 98%;
    color: #ff534c;
}

.bottm-btn-box {
    width: 70%;
    margin: auto;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    /* z-index: 190; */
    /* z-index: 1000; */
    z-index: 999;
    /* display: flex;
    justify-content: center;
    align-items: center; */
    padding-bottom: 1.5rem;
}

.bottom-nav{
    width: 100%;
    height: 1rem;
    border-top: 1px solid #e4e4e4;
    z-index: 1000;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: space-around;
    align-items: center;
    font-size: 0.22rem;
    color: #999999;
    background: #fff;
}

.bottom-nav img{
    width: 0.4rem;
    height: 0.4rem;
    margin-bottom: -.05rem;
}
.bottom-nav .active{
    color: #48C1FF;
}
.bottom-nav .active-sc{
    color: #009D7A;
}

.left-btn-box {
    position: fixed;
    top: 1.5rem;
    right: 0.3rem;
    z-index: 190;
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* 音频波动效果 */
.music-wrap {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.6);
    position: relative;
    display: none;
}

.music-wrap ul {
    position: absolute;
    bottom: 0;
    top: 0;
    left: 0;
    right: 0;
    display: flex;
    align-items: flex-end;
    flex-wrap: nowrap;
    font-size: 0;
}

.music-wrap ul li {
    background: #48c1ff;
    margin-left: 0.05rem;
    display: inline-block;
    width: 0.05rem;
    height: 100%;
}

.music-wrap ul li:first-child {
    margin-left: 0;
}

.m1 {
    animation: 0.8s 0.1s living linear infinite backwards normal;
    animation-delay: -1.1s;
}

.m2 {
    animation: 0.8s 0.3s living linear infinite backwards normal;
    animation-delay: -1.3s;
}

.m3 {
    animation: 0.8s 0.6s living linear infinite backwards normal;
    animation-delay: -1.6s;
}

@keyframes living {
    0% {
        transform: scaleY(1);
        transform-origin: 0 100%;
    }

    50% {
        transform: scaleY(0.3);
        transform-origin: 0 100%;
    }

    100% {
        transform: scaleY(1);
        transform-origin: 0 100%;
    }
}

.marker-icon-box {
    width: .36rem;
    height: .36rem;
    /* font-size: .12rem; */
    /* background: url(./assets/markerClusterer.png) no-repeat center center / 36px; */
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 .005rem .01rem 0 rgba(0, 0, 0, 0.2);
    border-radius: 50%;
}

.marker-icon-box .text {
    /* line-height: 26px; */
    /* color: #ff5a00; */
    font-size: .28rem;
    font-weight: bold;
    color: rgba(128, 189, 79, 1);
}


/* 实时轨迹用到的样式 */
.walking-marker-icon-box{
    width: .20rem;
    height: .20rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #FE656B;
    box-shadow: 0 .005rem .01rem 0 rgba(0, 0, 0, 0.2);
    border-radius: 50%;
}

.walking-location-box{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.walking-location-box .top{
display: flex;
justify-content: flex-end;
align-items: center;
padding: 0 .1rem 0 .46rem; 
height:.56rem;
border-radius:.1rem;
background:#fff url('./assets/walking_people.png') no-repeat .1rem center/.36rem;
font-size:.28rem;
color:rgba(51,51,51,1);
}

.walking-location-box .location-icon{
    padding-top: .1rem;
    min-width: 1.44rem;
    min-height: .77rem;
    background: url('./assets/walking-mylocation.png') no-repeat center center/.6rem;
}
</style>


<style lang="scss">
@import './components/common/css/customized.scss';
@import './components/common/css/new-style.scss';
</style>